import React from "react";
import PropTypes from "prop-types";
import 'react-dropdown/style.css';
import '../App.css';
import { Link as TextLink } from '@mui/joy';

const textUploadExisting1 = "Thank you for submitting the required documents. Please allow 3-5 business days for us to review. We'll call if\n " +
"additional information is needed and send an email once your request has been completed.\n\n" +
"OpenNet is available 24/7 for real-time loan updates and loan status inquiries.\n\n";
const textUploadExisting2 = "Sallie Mae School Assist\n";
const textUploadExisting3a = "844-8-ASSIST (844-827-7478)\n";
const textUploadExisting3b = "877-456-6221 – School Assist International Number";
const emailExisting = "SchoolAssist@SallieMae.com";
const textUploadExisting4 = "Important: To help safeguard our customers' information, all non-public personal information (NPI) for students,\n " +
 "borrowers, or cosigners, including SSN and Date of Birth, must be sent in an encrypted and secured manner.\n"+
 "NPI should never be in the body of your email correspondence with Sallie Mae Bank.\n\n";


const textUploadProspect1 = "Thanks for submitting the required documentation to review your school's eligibility for Sallie Mae Loan\n " +
 "products. If you think of any questions, please email us at ";
const emailProspect = "relationship_management_support@salliemae.com";
const textUploadProspect2 = "We'll contact you within 24 hours to confirm receipt of your documents.\n\nSallie Mae Relationship Management Team\n\n " +
 "Important: To help safeguard our customers' information, all non-public personal information (NPI) for students,\n " +
 "borrowers, or cosigners, including SSN and Date of Birth, must be sent in an encrypted and secured manner.\n " +
 "NPI should never be in the body of your email correspondence with Sallie Mae Bank.";


const textUploadDeposit1 = "Thanks! Please allow 3-5 business days for us to review your documents.\n";


const uploadFailedMessage = "Upload failed. Please try again later."

const UploadResultMessage = (props) => {
    // Force a true hard reload with cache busting to ensure Lambda@Edge runs
    const handleRetry = () => {
        // Add timestamp to force bypass cache and ensure fresh request to server
        const timestamp = Date.now();
        globalThis.location.href = '/?_t=' + timestamp;
    };

    if (props.uploadresult === "failure") {
        // If there's a specific error message, display it; otherwise use generic message
        const errorMessage = props.errorMessage || uploadFailedMessage;
        
        // Check if this is a token-related error (contains "token", "session", or "expired")
        const isTokenError = errorMessage && (
            errorMessage.toLowerCase().includes('token') || 
            errorMessage.toLowerCase().includes('session') || 
            errorMessage.toLowerCase().includes('expired')
        );
        
        if (isTokenError) {
            // Extract the message before "Please try again" and render with link
            const messageParts = errorMessage.split('Please try again');
            const messagePrefix = messageParts[0].trim();
            
            return (
                <div>
                    <p className="css-fix">{messagePrefix}</p>
                    <p>
                        <button 
                            onClick={handleRetry} 
                            className="btn custom-btn-primary small" 
                            style={{ display: 'inline-block', width: 'auto', padding: '8px 16px', cursor: 'pointer' }}
                        >
                            Please try again
                        </button>
                    </p>
                </div>
            );
        }
        
        // For non-token errors: don't show the specific error details, but show the button
        return (
            <div>
                <p>
                    <button 
                        onClick={handleRetry} 
                        className="btn custom-btn-primary small" 
                        style={{ display: 'inline-block', width: 'auto', padding: '8px 16px', cursor: 'pointer' }}
                    >
                        Please try again
                    </button>
                </p>
            </div>
        );
    }

    if (props.usertype === "deposit") {
        return (
            <div>
                <p className="css-fix">{textUploadDeposit1}</p>
                <p></p>
            </div>
        );
    }

    if (props.usertype === "existing") {
        return (
            <div>
                <p className="css-fix">{textUploadExisting1}</p>
                <p className="css-fix">{textUploadExisting2}</p>
                <p className="css-nobreakp">{textUploadExisting3a}</p>
                <p className="css-nobreakp">{textUploadExisting3b}</p>
                <p className="css-nobreakp"><TextLink href={"mailto:" + emailExisting} >
                    {emailExisting}
                </TextLink></p>
                <p></p>
                <p></p>
                <p className="css-fix">{textUploadExisting4}</p>
                <p></p>
                <p></p>
            </div>
        );
    }

    // this would be "prospect"
    return (
        <div>
            <p className="css-fix">{textUploadProspect1}<span><TextLink href={"mailto:" + emailProspect}>{emailProspect}</TextLink></span>.</p>
            <p className="css-fix">{textUploadProspect2}</p>
            <p></p>
            <p></p>
            <p></p>
            <br></br>
            <br></br>
        </div>
    );
}

UploadResultMessage.propTypes = {
    uploadresult: PropTypes.string.isRequired,
    usertype: PropTypes.string.isRequired,
    errorMessage: PropTypes.string
  };

export default UploadResultMessage;